import request from '../requestPB'
import { SERVER_DOMAIN as preFix, PROTO_MODULE } from '../constant'

// 卖家物流接口请求
export const sellerQueryExpress = ({ orderID }) => {
  return request({
    url: `${preFix}/order/sellerQueryExpress`,
    data: {
      orderID
    },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSSellerQueryExpressRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSSellerQueryExpressResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.ORDER,
    TOKEN_REQUIRED: true
  })
}
// 买家物流接口请求
export const buyerQueryExpress = ({ orderID }) => {
  return request({
    url: `${preFix}/order/buyerQueryExpress`,
    data: {
      orderID
    },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSBuyerQueryExpressRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSBuyerQueryExpressResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.ORDER,
    TOKEN_REQUIRED: true
  })
}
// 商品成色请求  POST /product/newDegreeInfoList
export const fetchNewDegreeInfoList = ({ kindID }) => {
  return request({
    url: `${preFix}/product/newDegreeInfoList`,
    method: 'POST',
    data: { kindID }
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductNewsRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductNewsResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT
    // TOKEN_REQUIRED: true
  })
}

// 商品图片上传接口 POST /product/uploadImage
export const uploadImage = ({ imgB64 }) => {
  return request({
    url: `${preFix}/product/uploadImage`,
    data: { imgB64 },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductImageUploadRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductImageUploadResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.PRODUCT,
    // TOKEN_REQUIRED: true
  })
}

// 寄卖物流 @token_required POST /consign/queryExpress
export const consignQueryExpress = ({ orderNo }) => {
  return request({
    url: `${preFix}/consign/queryExpress`,
    data: { orderNo },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSConsignQueryExpressRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSConsignQueryExpressResponse',
    ERROR_ACTION: 'toast',
    // PROTO_MODULE: PROTO_MODULE.PRODUCT,
    TOKEN_REQUIRED: true
  })
}
// 回收订单状查看物流 @token_required POST /recycle/queryExpress
export const recycleQueryExpress = ({ orderNo }) => {
  return request({
    url: `${preFix}/recycle/queryExpress`,
    data: { orderNo },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSRecycleQueryExpressRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSRecycleQueryExpressResponse',
    ERROR_ACTION: 'toast',
    // PROTO_MODULE: PROTO_MODULE.PRODUCT,
    TOKEN_REQUIRED: true
  })
}
